const EditIcon = ({ ...props }) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22.2312 2.26884C21.206 1.24372 19.544 1.24372 18.5188 2.26884L17.3617 3.42599L21.074 7.1383L22.2312 5.98116C23.2563 4.95603 23.2563 3.29397 22.2312 2.26884Z"
        fill="#5A4BDA"
      />
      <path
        d="M20.0133 8.19896L16.301 4.48665L7.90019 12.8875C7.28341 13.5043 6.83002 14.265 6.581 15.101L5.78122 17.7859C5.7026 18.0498 5.77494 18.3356 5.96967 18.5303C6.1644 18.725 6.45019 18.7974 6.71412 18.7188L9.39901 17.919C10.235 17.67 10.9957 17.2166 11.6125 16.5998L20.0133 8.19896Z"
        fill="#5A4BDA"
      />
      <path
        d="M5.75 5.24999C4.09315 5.24999 2.75 6.59314 2.75 8.24999V18.75C2.75 20.4068 4.09315 21.75 5.75 21.75H16.25C17.9069 21.75 19.25 20.4068 19.25 18.75V13.5C19.25 13.0858 18.9142 12.75 18.5 12.75C18.0858 12.75 17.75 13.0858 17.75 13.5V18.75C17.75 19.5784 17.0784 20.25 16.25 20.25H5.75C4.92157 20.25 4.25 19.5784 4.25 18.75V8.24999C4.25 7.42156 4.92157 6.74999 5.75 6.74999H11C11.4142 6.74999 11.75 6.41421 11.75 5.99999C11.75 5.58578 11.4142 5.24999 11 5.24999H5.75Z"
        fill="#5A4BDA"
      />
    </svg>
  )
}

export default EditIcon
